var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetoxlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3789 1.33594L12.7753 1.52869C15.4375 2.81971 17.1221 5.50933 17.1221 8.45446L17.1086 18.8857C17.1086 18.944 17.0591 18.9933 17.0005 18.9933H14.9735C14.8834 18.9933 14.8294 19.1009 14.8879 19.1726L20.0546 25.417C20.1627 25.547 20.3609 25.547 20.469 25.417L25.6357 19.1726C25.6942 19.1009 25.6447 18.9933 25.5501 18.9933H23.5231C23.4645 18.9933 23.4149 18.944 23.4149 18.8857V8.14515C23.4149 4.81451 21.0501 1.33594 17.7438 1.33594H16.7122",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5316 23.4575C14.0226 24.8292 12.0181 25.663 9.81537 25.663C5.13519 25.663 1.33789 21.8841 1.33789 17.2266C1.33789 11.928 9.81537 3.29883 9.81537 3.29883C9.81537 3.29883 12.401 5.93465 14.7163 9.18461",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88697 22.5265C6.27887 21.9124 5.0131 20.6169 4.43652 18.9941",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetoxlock);
export default __webpack_public_path__ + "static/media/detoxlock.41aa3167288a9e0fe9153c825f668c53.svg";
export { ForwardRef as ReactComponent };